export ListItemArea from "./ListItemArea"
export ListItemArticle from "./ListItemArticle"
export ListItemLocation from "./ListItemLocation"
export ListItemOrderHistory from "./ListItemOrderHistory"
export ListItemOrderHistoryDetails from "./ListItemOrderHistoryDetails"
export ListItemProduct from "./ListItemProduct"
export ListItemShoppingCart from "./ListItemShoppingCart"
export ListItemUser from "./ListItemUser"
export ListItemTransaction from "./ListItemTransaction"
export ListItemDestination from "./ListItemDestination"
export ListItemTenant from "./ListItemTenant"
export ListItemDeliveryNote from "./ListItemDeliveryNote"
export ListItemStockOut from "./ListItemStockOut"
export ListItemDocument from "./ListItemDocument"
export ListItemStock from "./ListItemStock"
export ListItemStoragePlace from "./ListItemStoragePlace"

export const handleDestroyError = err => {
  if (err.response && err.response.status === 422 && err.response.data.errors) {
    alert(err.response.data.errors)
  } else {
    alert("Ein Fehler ist aufgetreten, bitte neu laden.")
  }
}



// WEBPACK FOOTER //
// ./src/components/list_items/index.js